import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

const StatisticsPagerSettings = ({ limit, onSettingsUpdate }) => {
  const [rowLimit, setRowLimit] = useState(100);

  useEffect(() => {
    const limit = Number(localStorage.getItem('statistics_pager_preference'));
    if (limit && limit > 0) {
      onSettingsUpdate({ limit });
    }
  }, []);

  useEffect(() => {
    setRowLimit(limit);
  }, [limit]);

  const handleChange = e => {
    setRowLimit(e.target.value);
  };

  const handleBlur = e => {
    if (Number(rowLimit) > 0) {
      onSettingsUpdate({ limit: Number(rowLimit) });
      localStorage.setItem('statistics_pager_preference', rowLimit);
    }
  };

  const handleEnterPress = e => {
    if (e.key === 'Enter' && Number(rowLimit) > 0) {
      onSettingsUpdate({ limit: Number(rowLimit) });
      localStorage.setItem('statistics_pager_preference', rowLimit);
    }
  };

  return (
    <div className="statistics-pager-settings-wrapper">
      <span className="statistics-pager-settings-label">
        <FMessage id="statistics.pager-settings.label" />
      </span>
      <Input
        type="number"
        bsSize="sm"
        value={rowLimit}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyUp={handleEnterPress}
      />
    </div>
  );
};

export default StatisticsPagerSettings;
